import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import SearchInput from "../../../../Input/SearchInput";
import { jsx as _jsx } from "react/jsx-runtime";
function SearchInputCell(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(SearchInput, _extends({}, props));
}
export default SearchInputCell;